import { API_URL } from './authServices';

/* ──────────────────────────────────────────
   Centralized API fetch with JWT auth
   ────────────────────────────────────────── */

const STORAGE_KEY = 'liberty_auth';

function authHeader(): Record<string, string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const { token, expiration } = JSON.parse(raw);
    if (expiration && new Date(expiration) < new Date()) return {};
    if (token) return { Authorization: `Bearer ${token}` };
  } catch { /* ignore */ }
  return {};
}

/** Generic GET with auth */
export async function apiGet<T = any>(path: string, params?: Record<string, string | number>): Promise<T> {
  let url = `${API_URL}${path}`;
  if (params) {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) qs.append(k, String(v));
    url += `?${qs.toString()}`;
  }
  const res = await fetch(url, { headers: { ...authHeader() } });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Erro de conexao' }));
    throw err;
  }
  return res.json();
}

/** Generic POST with auth + JSON body */
export async function apiPost<T = any>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Erro de conexao' }));
    throw err;
  }
  return res.json();
}

/** Generic PUT with auth + JSON body */
export async function apiPut<T = any>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Erro de conexao' }));
    throw err;
  }
  return res.json();
}

/** Generic PATCH with auth + JSON body */
export async function apiPatch<T = any>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Erro de conexao' }));
    throw err;
  }
  return res.json();
}

/** Generic DELETE with auth */
export async function apiDelete<T = any>(path: string): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    method: 'DELETE',
    headers: { ...authHeader() },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Erro de conexao' }));
    throw err;
  }
  return res.json();
}
